// extracted by mini-css-extract-plugin
module.exports = {"statusFilter":"DeliveryRequests_statusFilter_1G73k","shadow-none":"DeliveryRequests_shadow-none_3qQxS","bg-none":"DeliveryRequests_bg-none_25Tgx"};